import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Sidebar collapsed={collapsed} />

      {/* Main area shifts right to accommodate sidebar */}
      <div
        className={`transition-all duration-300 ease-in-out ${
          collapsed ? "ml-16" : "ml-64"
        }`}
      >
        <Header
          onToggle={() => setCollapsed((v) => !v)}
          collapsed={collapsed}
        />
        <main className="p-6 min-h-[calc(100vh-64px)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
